import createIcon from '../../createIcon';

/**
 * @component @name Route
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTUuMThWN0MxOSA0Ljc5IDE3LjIxIDMgMTUgM0MxMi43OSAzIDExIDQuNzkgMTEgN1YxN0MxMSAxOC4xIDEwLjEgMTkgOSAxOUM3LjkgMTkgNyAxOC4xIDcgMTdWOC44MkM4LjE2IDguNCA5IDcuMyA5IDZDOSA0LjM0IDcuNjYgMyA2IDNDNC4zNCAzIDMgNC4zNCAzIDZDMyA3LjMgMy44NCA4LjQgNSA4LjgyVjE3QzUgMTkuMjEgNi43OSAyMSA5IDIxQzExLjIxIDIxIDEzIDE5LjIxIDEzIDE3VjdDMTMgNS45IDEzLjkgNSAxNSA1QzE2LjEgNSAxNyA1LjkgMTcgN1YxNS4xOEMxNS44NCAxNS41OSAxNSAxNi42OSAxNSAxOEMxNSAxOS42NiAxNi4zNCAyMSAxOCAyMUMxOS42NiAyMSAyMSAxOS42NiAyMSAxOEMyMSAxNi43IDIwLjE2IDE1LjYgMTkgMTUuMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Route = createIcon('Route', [
  [
    'path',
    {
      d: 'M19 15.18V7C19 4.79 17.21 3 15 3C12.79 3 11 4.79 11 7V17C11 18.1 10.1 19 9 19C7.9 19 7 18.1 7 17V8.82C8.16 8.4 9 7.3 9 6C9 4.34 7.66 3 6 3C4.34 3 3 4.34 3 6C3 7.3 3.84 8.4 5 8.82V17C5 19.21 6.79 21 9 21C11.21 21 13 19.21 13 17V7C13 5.9 13.9 5 15 5C16.1 5 17 5.9 17 7V15.18C15.84 15.59 15 16.69 15 18C15 19.66 16.34 21 18 21C19.66 21 21 19.66 21 18C21 16.7 20.16 15.6 19 15.18Z',
      key: '1cvh9g',
    },
  ],
]);

export default Route;
